import React, { useState, useEffect } from 'react';
import Select from 'react-select';

export default ({ optionsProp = [], selectedNewOptionHandler }) => {
    const [options, setOptions] = useState(optionsProp);
    const [selectedValues, setSelectedValues] = useState([]);

    const handleChange = (values) => {
        setSelectedValues(values);
        selectedNewOptionHandler(values);
        // console.log('values', values)
    };

    useEffect(() => {
        setOptions(optionsProp);
    }, [optionsProp])
    return (
        <Select
            defaultValue={[options[0]]}
            isMulti
            name="colors"
            options={options}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={handleChange}
            value={selectedValues}
        />
    );
};